import MessageBaseController from '../common/message.base.controller'

class MessageEditController extends MessageBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, MessageService, Modal, $translate, $stateParams, UserService) {

    super(Auth, $state, User, MessageService, Modal, $translate, $stateParams);

    this.message = 'Message create'
    this.languages = []
    this.messageTypes = []
    this.loggedInUser = this.User.getUser();
    this.$translate = $translate;

    this.loading = false

    this.model = {};
    this.branchId = this.User.getUser().branchId;

  }

  reset() {
    this.$onInit();
  }

  $onInit() {

    this.Service.get(this.loggedInUser.languageId, this.$stateParams.id)
      .then((response) => {
        this.model = response
      })
      .catch((err) => {
        console.log(err);
      })

    this.types = ['M', 'T', 'R', 'SM', 'NP', 'UI', 'H'];
    this.messageTypes = this.types.map((type) => {
      return {
        label: type + ' | ' + this.$translate.instant(`message.types.${type}`),
        value: type
      };
    });
  }

  submit() {
    this.loading = true

    this.Service.update(this.loggedInUser.languageId, this.model.id, this.model, this.branchId)
      .then((response) => {
        window.history.go(-1)
      })
      .catch((err) => {
        if (err && err.data && err.data.errors && err.data.errors.length) {
          err.data.errors.map((e) => {
            this.errorMessage += e.message + '<br/>'
          })
        }
        else {
          console.error(err);
        }
      })
      .finally(() => {
        this.loading = false
      })
  }
}

export default MessageEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/edit/message.edit.controller.js